import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";

@Entity({ create: "cartCheckout" })
export class CartCheckout {
	@Field()
	public orderId?: ID;

	@Field()
	public orderTransactionId?: ID;
}



// WEBPACK FOOTER //
// ./src/panels/catalog/cart/entities/CartCheckout.ts